import React, { memo } from "react";
import { FiBox } from "react-icons/fi";
import { IoIosArrowForward } from "react-icons/io";
import ClipLoader from "react-spinners/ClipLoader";
import { useQueryUpdates } from "../hooks";
import styles from "@components/Queries/QueryUpdate.module.css";

/**
 * QueryUpdateItem component - displays a single query update
 */
const QueryUpdateItem = memo(({ item }) => (
  <div className={styles.queryUpdate__infobox}>
    <span>
      <FiBox className={styles.queryUpdate__icon} />
    </span>
    <h6 className={styles.queryUpdate__name}>{item?.subHead}</h6>
    <h4 className={styles.queryUpdate__dateTime}>
      {item?.startDate?.substring(0, 10)}
    </h4>
    <p className={styles.queryUpdate__dueDate}>{item?.status}</p>
    <p className={styles.queryUpdate__dueDate}>{item?.description}</p>
    <h6 className={styles.queryUpdate__name}>{item?.subject}</h6>
  </div>
));

QueryUpdateItem.displayName = "QueryUpdateItem";

/**
 * QueryUpdate component - displays query update history timeline
 */
const QueryUpdate = ({ recId }) => {
  const { updates, loading } = useQueryUpdates(recId);

  return (
    <div className={styles.queryUpdate}>
      <div className={styles.queryUpdate__heading}>Query Update</div>
      <div className={loading ? "showLoader" : ""}>
        {loading && (
          <div className="loaderOuterBox">
            <div className="loaderInnerBox">
              <ClipLoader loading={loading} color="#3901ff" />
            </div>
          </div>
        )}
        
        <div className={styles.queryUpdate__mainbox}>
          <div className={styles.queryUpdate__innerbox}>
            <div className={styles.queryUpdate__arrow}>
              <IoIosArrowForward />
            </div>
            <div className={styles.queryUpdate__updateArea}>
              {updates.map((item, index) => (
                <QueryUpdateItem key={`${item?.startDate}-${index}`} item={item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(QueryUpdate, (prevProps, nextProps) => {
  return prevProps.recId === nextProps.recId;
});
